import type { ReactNode } from "react";

export type BadgeTone = "accent" | "red" | "muted";

const TONES: Record<BadgeTone, string> = {
  accent: "bg-blue-wash text-blue",
  red: "bg-red-wash text-red",
  muted: "bg-ice-2 text-ink-2",
};

/** Small text chip. Use Status instead when the mark is a live/linked/idle state. */
export function Badge({ tone, children }: { tone: BadgeTone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-note font-semibold ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
